<template>
  <div>
    <b-container class="b-container">
      <b-row>
        <b-col md="8">
          <h1>{{this.$store.state.miscData.Name}}</h1>
        </b-col>
        <b-col md="4" class="pb-3 pt-3">
          <SortBar id="sortBar"></SortBar>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="3">
          <Filters id="filters" @filtersUpdated="updateFilters"></Filters>
        </b-col>
        <b-col md="9">
          <p></p>
          <b-row v-if="$store.state.loading" class="justify-content-center">
            <b-spinner label="Spinning">Bezig met laden...</b-spinner>
          </b-row>
          <p v-else-if="$store.getters.noResults">Geen resultaten. Probeer andere filters.</p>

          <!-- Jobs -->
          <JobCard
            v-else
            v-for="job in getCurrentPageJobs($store.getters.slicedFilteredJobs)"
            v-bind:job="job"
            v-bind:key="job.Id"
          />

          <!-- Paging numbers -->
          <div class="row">
            <div class="col-md-12">
              <div class="pagination">
                <!-- Previous Button -->
            <div v-if="currentPage > 1">
              <button v-on:click="setPage(currentPage - 1)" class="btn-prev">
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.29999 11.3L0.699987 6.7C0.599987 6.6 0.529321 6.49166 0.487988 6.375C0.446654 6.25833 0.425654 6.13333 0.424988 6C0.424988 5.86666 0.445988 5.74166 0.487988 5.625C0.529988 5.50833 0.600654 5.4 0.699987 5.3L5.29999 0.699995C5.48332 0.516662 5.71665 0.424995 5.99999 0.424995C6.28332 0.424995 6.51665 0.516662 6.69999 0.699995C6.88332 0.883328 6.97499 1.11666 6.97499 1.4C6.97499 1.68333 6.88332 1.91666 6.69999 2.1L2.79999 6L6.69999 9.89999C6.88332 10.0833 6.97499 10.3167 6.97499 10.6C6.97499 10.8833 6.88332 11.1167 6.69999 11.3C6.51665 11.4833 6.28332 11.575 5.99999 11.575C5.71665 11.575 5.48332 11.4833 5.29999 11.3Z" fill="white"/>
                </svg>
              </button>
            </div>

            <!-- Numbers -->
            <div v-for="page in getPagingPages($store.getters.slicedFilteredJobs)" :key="page" class="pagingNum">
              <!-- Selected -->
              <div v-if="page == currentPage">
                <span>{{ page }}</span>
              </div>

              <!-- Dots -->
              <div v-else-if="page == -1">
                ...
              </div>

              <!-- Page Button -->
              <button v-else v-on:click="setPage(page)">
                {{ page }}
              </button>
            </div>

            <!-- Next Button -->
            <div v-if="currentPage < totalPages">
              <button v-on:click="setPage(currentPage + 1)" class="btn-next">
                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.09997 0.699998L6.69998 5.3C6.79998 5.4 6.87064 5.50833 6.91198 5.625C6.95331 5.74166 6.97431 5.86666 6.97498 6C6.97498 6.13333 6.95398 6.25833 6.91198 6.375C6.86998 6.49166 6.79931 6.6 6.69998 6.7L2.09998 11.3C1.91664 11.4833 1.68331 11.575 1.39998 11.575C1.11664 11.575 0.883309 11.4833 0.699976 11.3C0.516643 11.1167 0.424975 10.8833 0.424975 10.6C0.424975 10.3167 0.516642 10.0833 0.699976 9.9L4.59998 6L0.699975 2.1C0.516642 1.91666 0.424975 1.68333 0.424975 1.4C0.424974 1.11666 0.516642 0.883332 0.699975 0.699998C0.883308 0.516665 1.11664 0.424997 1.39997 0.424997C1.68331 0.424997 1.91664 0.516665 2.09997 0.699998Z" fill="white"/>
                </svg>
              </button>
            </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <FilterButtonAndModal id="filterButtonAndModal"></FilterButtonAndModal>
  </div>
</template>
<script>
import JobCard from "../components/JobOverviewPage/JobCard.vue";
import Filters from "../components/JobOverviewPage/Filters.vue";
import SortBar from "../components/JobOverviewPage/SortBar.vue";
import FilterButtonAndModal from "../components/JobOverviewPage/FilterButtonAndModal.vue";
export default {
  name: "JobsOverviewPage",
  components: {
    JobCard,
    Filters,
    SortBar,
    FilterButtonAndModal
  },
  async mounted() {
    this.isBusy = true;
    try {
      await this.$store.dispatch("load");
    } catch (ex) {
      this.error = "Failed to load data";
    } finally {
      this.isBusy = false;
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 6,
      totalPages: 1,
    }
  },
  methods: {
    updateFilters: function() {
      //Set currentPage to 1
      this.currentPage = 1;
    },

    getCurrentPageJobs: function(jobs){
      //Create list
      let results = [];

      //Create minCounter
      let minCounter = (this.currentPage * this.pageSize) - this.pageSize;

      //Create maxCounter
      let maxCounter = (this.currentPage * this.pageSize);

      //Loop from min to max
      for(let i = minCounter; i < maxCounter; i++) {
        //Check if valid
        if(i < jobs.length) {
          //Add to list
          results.push(jobs[i]);
        }
      }

      //Return results
      return results;
    },

    getPagingPages: function(jobs){
      //Create result list
      let result = [];

      //Check if jobs is valid
      if (jobs !== null
          && jobs !== undefined
          && jobs !== 'undefined') {
        //Create var for totalPages
        let totalPages = Math.floor(jobs.length / this.pageSize);

        //Add last page if needed
        if ((jobs.length % this.pageSize) > 0) {
          //Add the last page
          totalPages += 1;
        }

        //Set totalPages
        this.totalPages = totalPages;

        //Populate list
        if(this.currentPage < 5) {
          //Loop from 1 to 7
          for(let i = 1; i < 8; i++) {
            //Check if valid
            if(i > 0 && i <= totalPages) {
              //Check if under 6
              if(i < 6) {
                //Add to result
                result.push(i);
              }
              //Check if sixth element
              else if(i == 6) {
                //Add to result
                result.push(-1);
              }
              //Check if seventh element
              else if(i == 7) {
                //Add to result
                result.push(this.totalPages);
              }
            }
          }
        }
        else if(this.currentPage > (this.totalPages - 4)) {
          //Loop from 1 to 7
          for(let i = (this.totalPages - 6); i <= this.totalPages; i++) {
            //Check if valid
            if(i > 0 && i <= totalPages) {
              //Check if first element
              if(i == (this.totalPages - 6)) {
                //Add to result
                result.push(1);
              }
              //Check second element
              else if(i == (this.totalPages - 5) && i < this.totalPages) {
                //Add to result
                result.push(-1);
              }
              //Check if seventh element
              else {
                //Add to result
                result.push(i);
              }
            }
          }
        }
        else {
          //Loop from currentPage minus 3 to currentPage plus 3
          for(let i = (this.currentPage - 3); i < (this.currentPage + 4); i++) {
            //Check if valid
            if(i > 0 && i <= totalPages) {
              //Check if first element
              if(i == (this.currentPage - 3)) {
                //Add to result
                result.push(1);
              }
              //Check if under 6
              else if(i > (this.currentPage - 2) && i < (this.currentPage + 2)) {
                //Add to result
                result.push(i);
              }
              //Check if sixth element
              else if(i == (this.currentPage + 2) || i == (this.currentPage - 2)) {
                //Add to result
                result.push(-1);
              }
              //Check if seventh element
              else if(i == (this.currentPage + 3)) {
                //Add to result
                result.push(this.totalPages);
              }
            }
          }
        }
      }

      //Return the result
      return result;
    },

    setPage: function(pageNum) {
      //Check if page is below or equal to total pages
      if(pageNum <= this.totalPages
        && pageNum > 0) {
          //Set new currentPage
          this.currentPage = pageNum;
      }
    }
  }
};
</script>
<style scoped>
/* shared */
#filterButtonAndModal {
  display: none;
}
/* > 992px*/
@media screen and (min-width: 992px) {
}

/* =< 767 */
@media screen and (max-width: 767px) {
  #filterButtonAndModal {
    display: block;
  }
  #filters {
    display: none;
  }
  #sortBar {
    display: none;
  }
}
</style>